import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  WhiteSpace,
  InputItem,
  Button,
  WingBlank,
  TextareaItem,
  Toast,
} from "antd-mobile";
import "./addGroup.scss";
import axios from "../../../service/axios";
import { connect } from "dva";
import { createForm } from "rc-form";
export class editGroupPrefix extends Component {
  state = {
    oldName: "",
    groupErr:''
  }
  componentDidMount() {
    console.log(this.props.location.search.split('?')[1])
    this.setState({
      oldName: this.props.location.search.split('?')[1],
    });
  }
  onAddGroup() {
    this.props.form.validateFields({ force: true }, error => {
      if (!error) {
        this.addGroup(this.props.form.getFieldsValue().oldName);
      }
    });
  }
  addGroup(data) {
    axios
      .post("/api/group/prefixname/update", {
        oldPrefix:this.state.oldName,
        newPrefix:data
      })
      .then(res => {
        if (res) {
          if (res.status == 200) {
            Toast.success(res.message, 1, () => {
              this.props.history.replace("/groupPrefixList");
            });
          } else {
            Toast.fail(res.message);
          }
        }
      })
      .catch(res => {
        Toast.hide();
      });
  }
  validaetName = (rule, value, callback) => {
    console.log(111)
    if (value) {
      if (value.trim()) {
        if (/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,11}$/.test(value)) {
          callback();
          this.setState({
            groupErr:''
          })
        } else {
          callback(new Error("名称只支持1~11位中文数字字母和下划线"));
          this.setState({
            groupErr:'名称只支持1~11位中文数字字母和下划线'
          })
        }
      } else {
        callback(new Error("请填写群组名"));
        this.setState({
          groupErr:'请填写群组名'
        })
      }
    } else {
      callback(new Error("请填写群组名"));
      this.setState({
        groupErr:'请填写群组名'
      })
    }
  };
  render() {
    const {oldName,groupErr} = this.state;
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <div className="addgroup">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
          >
            修改群组前缀
          </NavBar>
        </div>
        <div className="sub-container">
          <List renderFooter={() => getFieldError("name") || groupErr}>
          <InputItem
              {...getFieldProps("oldName", {
                rules: [
                  {
                    validator: this.validaetName,
                  },
                ],
                initialValue: oldName,
              })}
              clear
              ref={el => (this.autoFocusInst = el)}
              maxLength="11"
              placeholder="请填写群组名"
            >
              群组名字
            </InputItem>
          </List>
          <WhiteSpace size="xl" />
          <WingBlank>
            <Button type="primary" onClick={() => this.onAddGroup()}>
              修改
            </Button>
          </WingBlank>
          <WhiteSpace size="xl" />
        </div>
      </div>
    );
  }
}
export default connect(
)(createForm()(editGroupPrefix));
